import {
  IconButton,
  Checkbox,
  HStack,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  Button,
  Box
} from '@chakra-ui/react'
import { FC, Key, useMemo } from 'react'
import Highlighter from 'react-highlight-words'
import { GiPlainCircle } from 'react-icons/gi'

import useTable from '@hook/shared/use-table'

import { ITableGridRow } from '@base/@types/components/Layout/TableGrid'

const TableGridItemParametrizationReabRoute: FC<{ [key: string]: any }> = ({
  data
}) => {
  const { actions, columns, query } = useTable()

  const rows = useMemo<ITableGridRow[]>(() => {
    const res = []
    for (const column of columns) {
      if (column.columns && column.columns.length > 0) {
        for (const row of column.columns) {
          res.push({
            id: row.id,
            value: data[row.id],
            align: row.align || 'left'
          })
        }
      } else {
        res.push({
          id: column.id!,
          value: data[column.canPrint ? column.id! : column.group],
          align: column.align || 'left'
        })
      }
    }
    return res
  }, [columns, data])

  return (
    <tr>
      {actions && actions.length > 0 && (
        <td>
          <HStack
            spacing={2}
            w="100%"
            alignItems="center"
            justifyContent="center"
          >
            {actions.map((action, index) => {
              if (action.type === 'icon') {
                return (
                  <IconButton
                    key={`table-action-${index}`}
                    aria-label="Abrir modal"
                    icon={action.icon}
                    size="xs"
                    onClick={() => action.onSelect!(data)}
                    _hover={{
                      bg: 'yellow.200'
                    }}
                    _active={{
                      bg: 'yellow.100'
                    }}
                  />
                )
              }

              if (action.type === 'checkbox') {
                if (action.isMulti) {
                  return (
                    <Checkbox
                      key={`table-action-${index}`}
                      colorScheme="red"
                      isChecked={action.selecteds.includes(data['id-id'])}
                      borderColor="blackAlpha.400"
                      alignItems="center"
                      onChange={() => {
                        if (action.onChange) {
                          action.onChange(data)
                        }
                      }}
                    />
                  )
                } else {
                  return (
                    <Checkbox
                      key={`table-action-${index}`}
                      colorScheme="yellow"
                      isChecked={action.isChecked}
                      borderColor="blackAlpha.400"
                      alignItems="center"
                      isDisabled={
                        action.selecteds !== 0
                          ? action.selecteds !== data['id-id']
                          : false
                      }
                      onChange={() => {
                        if (action.onChange) {
                          action.onChange(data)
                        }
                      }}
                    />
                  )
                }
              }
            })}
          </HStack>
        </td>
      )}
      {rows.map(({ id, value, align }, key) => (
        <td
          id={id}
          className="td-element"
          key={`${id}-${key}`}
          align={align || 'left'}
        >
          <>
            {(() => {
              if (id === 'rota-loja-id') {
                return (
                  <div>
                    {value.substring(0, value.length - 1).split('|')[0]}{' '}
                    {value?.substring(0, value.length - 1).split('|').length >
                      1 && (
                      <Popover>
                        <PopoverTrigger>
                          <Button
                            size="sm"
                            // variant="ghost"
                            aria-label="More info"
                            ml={2}
                          >
                            {' '}
                            +{' '}
                            {value?.substring(0, value.length - 1).split('|')
                              .length - 1}
                          </Button>
                        </PopoverTrigger>
                        <PopoverContent>
                          <PopoverArrow />
                          <PopoverCloseButton />
                          <PopoverBody bg="white">
                            {value
                              .substring(0, value.length - 1)
                              ?.split('|')
                              .slice(1)
                              .map((item: any, index: Key) => (
                                <Box key={index}>{item}</Box>
                              ))}
                          </PopoverBody>
                        </PopoverContent>
                      </Popover>
                    )}
                  </div>
                )
              } else if (id === 'rota-dia') {
                return (
                  <div>
                    {value.substring(0, value.length - 1).split('|')[0]}{' '}
                    {value?.substring(0, value.length - 1).split('|').length >
                      1 && (
                      <Popover>
                        <PopoverTrigger>
                          <Button
                            size="sm"
                            // variant="ghost"
                            aria-label="More info"
                            ml={2}
                          >
                            {' '}
                            +{' '}
                            {value?.substring(0, value.length - 1).split('|')
                              .length - 1}
                          </Button>
                        </PopoverTrigger>
                        <PopoverContent>
                          <PopoverArrow />
                          <PopoverCloseButton />
                          <PopoverBody bg="white">
                            {value
                              .substring(0, value.length - 1)
                              ?.split('|')
                              .slice(1)
                              .map((item: any, index: Key) => (
                                <Box key={index}>{item}</Box>
                              ))}
                          </PopoverBody>
                        </PopoverContent>
                      </Popover>
                    )}
                  </div>
                )
              } else if (id === 'aprovacao-status' && value === 2) {
                return <GiPlainCircle color="green" />
              } else if (id === 'aprovacao-status' && value === 3) {
                return <GiPlainCircle color="red" />
              } else {
                return (
                  <div>
                    {query.length > 0 ? (
                      <Highlighter
                        searchWords={String(query).split(' ')}
                        textToHighlight={String(value)}
                      />
                    ) : (
                      value
                    )}
                  </div>
                )
              }
            })()}
          </>
        </td>
      ))}
    </tr>
  )
}

export default TableGridItemParametrizationReabRoute
